var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.val)?_c('div',[_vm._t("default",null,{"val":_vm.val})],2):_c('span',{staticClass:"skeleton skeleton--line",class:_vm.skeletonClass,style:(_vm.skeletonStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }